import React from "react";
import { useTranslation } from "react-i18next";
import CustomFilterInput from "../../shared/CustomFilterInput";
import AppButton from "../../shared/AppButton";
import { FaFilter, FaUndo } from "react-icons/fa";

function DashboardFilter({ showFilter, formik, isLoading = false }) {
  const { t } = useTranslation();

  const maxToDate = formik.values.from_date
    ? (() => {
        const date = new Date(`${formik.values.from_date}T00:00:00`);
        date.setMonth(date.getMonth() + 1);
        return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(
          2,
          "0",
        )}-${String(date.getDate()).padStart(2, "0")}`;
      })()
    : undefined;

  if (!showFilter) return null;

  const handleApplyFilter = async () => {
    await formik.submitForm();
  };

  const handleReset = async () => {
    formik.resetForm();
    setTimeout(() => {
      formik.submitForm();
    }, 0);
  };

  return (
    <div className="bg-white p-1.5 rounded-lg border border-slate-200 mb-2 ">
      <div className="flex w-full justify-end space-x-2 gap-1.5 items-end">
        <div className=" flex flex-row items-center space-x-2">
          <label className=" font-semibold text-[12px] text-gray-700 mb-0.5 capitalize">
            {t("From Date")}
          </label>
          <CustomFilterInput
            // label={t("From Date")}
            name="from_date"
            type="date"
            value={formik.values.from_date}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            disabled={isLoading}
          />
        </div>
        <div className=" flex flex-row items-center space-x-2">
          <label className=" font-semibold text-[12px] text-gray-700 mb-0.5 capitalize">
            {t("To Date")}
          </label>
          <CustomFilterInput
            // label={t("To Date")}
            name="to_date"
            type="date"
            value={formik.values.to_date}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            min={formik.values.from_date}
            max={maxToDate}
            disabled={isLoading}
          />
        </div>
        <div className="flex justify-end gap-1">
          <AppButton
            title={t("Reset")}
            variant="reset"
            disabled={isLoading}
            onClick={handleReset}
            className="!border-gray-400 !bg-slate-100 !text-gray-600 hover:!bg-slate-200 !px-4"
            startIcon={<FaUndo className="!text-[12px]" />}
          />
          <AppButton
            title={t("Apply Filter")}
            onClick={handleApplyFilter}
            isLoading={isLoading}
            disabled={isLoading}
            startIcon={<FaFilter className="!text-[12px]" />}
          />
        </div>
      </div>
    </div>
  );
}

export default DashboardFilter;
